/*
 *
 *  Contact
 *  contains basic js for the contact page
 *  !! Created by Ilse on 05/08/2016
 *
 */
import "../elements/google-maps";

// 1. CreateGoogleMaps
// build the google maps with the CreateGoogleMaps  function (elements/google-maps)
$(document).ready(function () {
    // Create google maps
    var objGoogleMaps = CreateGoogleMaps(arrCompanyInfo, "google-maps-contact");

    // Create marker
    CreateGoogleMapsMarker(objGoogleMaps, arrCompanyInfo);
});
